import { GameStakeSelectorProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameStakeSelectorProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { VerticalLayout } from "@lib/titan2/dist/game/control/layout/VerticalLayout";
import { Point } from "pixi.js";
/**
 * StakeSelectorLandscapeProperties.ts
 */
export class StakeSelectorLandscapeProperties extends GameStakeSelectorProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.position = new Point(0, 0);
        this.scale.set(1);
        this.disabledPositionOffset = new Point(0, 77);
        this.hasSeparateValuePanel = true;
        this.hideToggleButton = false;
        this.closeOnSelection = true;
        this.toggleButtonProperties.position.set(1381, 115);
        this.panelProperties.layout = new VerticalLayout(-2);
        this.panelProperties.position = new Point(732, 55);
        this.panelProperties.scale.set(0.69);
        this.valueButtonProperties.disableTextAlpha = 0;
        this.valueButtonProperties.textFieldProperties.size = new Point(200, 100);
        this.valueButtonProperties.textFieldOffset.set(0, 0);
        this.toggleButtonProperties.trackingId = GameStyle.STAKE_BUTTON;
    }
    createToggleButtonTextFieldProperties() {
    }
}
//# sourceMappingURL=StakeSelectorLandscapeProperties.js.map